import script from "./RenderlessLaravelVuePagination.vue?vue&type=script&lang=js"
export * from "./RenderlessLaravelVuePagination.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__